import useSWR from 'swr';
import type { Outlet } from '../outletOrServiceCategory/types';

export function useVendorOutlets(vendorId: number): Outlet[] {
  const { data: outlets } = useSWR<Outlet[], any, { suspense: true }>(
    {
      url: `supplier/outlet_or_service_category/`,
      method: 'GET',
      queryParams: { vendor: vendorId },
    },
    { suspense: true },
  );
  return outlets;
}
